import { format, isValid, parse, parseISO } from 'date-fns';

export const DATE_VALUE_TODAY = 'today';

const DATE_VALUE_REGEXP = /^\d\d\d\d-\d\d-\d\d$/;
export const DATE_FORMAT = 'yyyy-MM-dd';

export const DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mmXXX";
export const DATETIME_VALUE_REGEXP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}([+-]\d{2}:\d{2}|Z)$/;

export function isValidDateString(date: string): boolean {
  return (
    date === DATE_VALUE_TODAY ||
    (!!date.match(DATE_VALUE_REGEXP) && isValid(parse(date, DATE_FORMAT, new Date()))) ||
    (DATETIME_VALUE_REGEXP.test(date) && isValid(parseISO(date)))
  );
}

/**
 * Preserves valid stored dates/datetimes and resolves the virtual "today" value.
 * Invalid input returns undefined. Kept independent of legacy field/model code.
 * @param includeTime When true and resolving "today", includes the current time in DATETIME_FORMAT.
 */
export function parseDate(
  date: string | undefined,
  includeTime = false
): string | undefined {
  if (!date || !isValidDateString(date)) {
    return undefined;
  } else if (date === DATE_VALUE_TODAY) {
    return format(new Date(), includeTime ? DATETIME_FORMAT : DATE_FORMAT);
  } else {
    return date;
  }
}

export function parseDatetime(date: string | undefined): string | undefined {
  return parseDate(date, true);
}
